import { render } from "./PamCardList.vue?vue&type=template&id=069bad32&scoped=true&ts=true"
import script from "./PamCardList.vue?vue&type=script&lang=ts"
export * from "./PamCardList.vue?vue&type=script&lang=ts"

import "./PamCardList.vue?vue&type=style&index=0&id=069bad32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069bad32"]])

export default __exports__